
import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { DropletIcon } from 'lucide-react';
import { Formula } from '@/types/formula';
import { Badge } from '@/components/ui/badge';

interface FormulaCardProps {
  formula: Formula;
  onViewDetails: (formula: Formula) => void;
}

export const FormulaCard = ({ formula, onViewDetails }: FormulaCardProps) => {
  return (
    <Card className="hover:border-primary/50 transition-colors">
      <CardHeader className="pb-2">
        <div className="flex justify-between items-start">
          <div className="flex items-center gap-2">
            <DropletIcon className="h-5 w-5 text-primary" />
            <CardTitle className="text-base">{formula.name}</CardTitle>
          </div>
          <Badge variant="outline">{formula.status}</Badge>
        </div>
        <CardDescription className="line-clamp-2">{formula.description || 'No description provided'}</CardDescription>
      </CardHeader>
      <CardContent className="pb-2">
        <div className="text-sm">
          <p><span className="text-muted-foreground">Components:</span> {formula.component_count}</p>
          <p><span className="text-muted-foreground">Created:</span> {new Date(formula.created_at).toLocaleDateString()}</p>
        </div>
      </CardContent>
      <CardFooter>
        <Button 
          variant="outline" 
          size="sm" 
          className="w-full"
          onClick={() => onViewDetails(formula)}
        >
          View Details
        </Button>
      </CardFooter>
    </Card>
  );
};
